import React, { useMemo } from "react";
import { useTranslations } from "../i18n/useTranslations";
import { getChallanges } from "./data";

export const ChallengesSection = () => {
  const { t, lang } = useTranslations();
  const challenges = useMemo(() => getChallanges(lang), [lang]);

  return (
    <>
      <div
        role="heading"
        className="elm-text-dd-gray-900 elm-font-sans elm-text-sm elm-font-normal elm-uppercase elm-m-0 elm-mb-3"
      >
        {t("Challenges")}
      </div>
      <ul className="elm-m-0 elm-p-0 elm-grid elm-grid-flow-col elm-grid-cols-2 elm-gap-2 elm-list-none w-full elm-flex-grow">
        {challenges.map((item, index) => (
          <li key={index} className="elm-flex">
            <a
              href={item.href}
              className="elm-flex elm-flex-col elm-w-full elm-no-underline elm-text-dd-gray-900 elm-rounded-xl elm-border-0 elm-border-b elm-border-solid elm-border-gray-100"
            >
              <picture>
                <source media="(min-width: 768px)" srcSet={item.imageSrc.desktop} />
                <img
                  src={item.imageSrc.mobile}
                  alt={item.title}
                  className="elm-w-full elm-block elm-rounded-xl"
                />
              </picture>
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};
